export default __webpack_public_path__ + "11cc022b2fb4e40bd9b8f045c3e789f4.png";